import React, { useMemo, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SendPreviewDialog from '../../changelog/components/editions/SendPreviewDialog';
import TemplatePreviewPane from './editor/TemplatePreviewPane';
import useTemplatePreview from '../hooks/useTemplatePreview';
import { formFromTemplate, variantTitle } from '../onboardingAdminConfig';

/**
 * Prévia de um modelo salvo, aberta direto da lista (sem passar pelo editor).
 * O modo de exemplo escolhido vale para a prévia na tela e para a prévia por e-mail.
 * @param {{ template: Object, onClose: Function, onEdit: Function, notify: Function }} props
 */
function TemplatePreviewDialog({ template, onClose, onEdit, notify }) {
  const form = useMemo(() => formFromTemplate(template), [template]);
  const [previewToOpen, setPreviewToOpen] = useState(false);
  const [mode, setMode] = useState('');
  const { preview, sendPreview, isSendingPreview } = useTemplatePreview(form, notify, mode);

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="caption" color="text.secondary" component="div">
          {variantTitle(template)} · {form.key}
        </Typography>
        <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600 }}>Prévia do e-mail</Typography>
      </DialogTitle>
      <DialogContent dividers>
        <TemplatePreviewPane preview={preview} modes={template.sample_modes} mode={mode} onModeChange={setMode} />
      </DialogContent>
      <DialogActions sx={{ px: 3, justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
        <Button startIcon={<SendOutlinedIcon />} disabled={isSendingPreview} onClick={() => setPreviewToOpen(true)}>
          {isSendingPreview ? 'Enviando prévia...' : 'Enviar prévia'}
        </Button>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button onClick={onClose}>Fechar</Button>
          <Button variant="contained" startIcon={<EditOutlinedIcon />} onClick={() => onEdit(template)}>Editar</Button>
        </Box>
      </DialogActions>

      <SendPreviewDialog
        subtitle={form.subject || form.key}
        open={previewToOpen}
        onClose={() => setPreviewToOpen(false)}
        onSubmit={(to) => {
          setPreviewToOpen(false);
          sendPreview(to);
        }}
      />
    </Dialog>
  );
}

export default TemplatePreviewDialog;
